import React from 'react';
import styled from 'styled-components';
import FooterCol from './FooterCol';
import PText from './PText';

const FooterStyle = styled.div`
  
  background-color: var(--deep-dark);
  padding-top: 5rem;

  .container {
    display: flex;
    gap: 3rem;
  }

  .footer__col1 {
    flex: 2;
  }

  .footer__col2,
  .footer__col3,
  .footer__col4 {
    flex: 1;
  }

  .footer__col1__title {
    font-size: 3.5rem;
    margin-bottom: 1rem;
  }

  .copyright {
    background-color: var(--dark-bg);
    text-align: left;
    padding: 1rem 0;
    margin-top: 5rem;

    .para {
      margin-left: 0;
    }
  }

  @media only screen and (max-width: 1440px) {
    .container {
      //flex-direction: column;
      //gap: 0;

      & > div {
        //margin-top: 5rem;
        padding: 10px;
      }
    }
  }

  @media only screen and (max-width: 1024px) {
    
    
  }
  @media only screen and (max-width: 768px) {
    .container {
      flex-direction: column;
      gap: 0;

      & > div {
        margin-top: 5rem;
        //padding: 10px;
      }
    }

    .footer__col1 .para {
      max-width: 100%;
    }

    .copyright {
      .container {
        div {
          margin-top: 0;
        }
      }
    }
  }
`;

export default function Footer() {
    return (
        <FooterStyle>
            <div className="container">
                <div className="footer__col1">
                    <h1 className="footer__col1__title">Maks Eremin</h1>
                    <PText>
                        I am a front-end developer of websites, I create professional websites.
                        I love art and always try to show the unique views of the audience with my design.
                    </PText>
                </div>
                <div className="footer__col2">
                    <FooterCol
                        heading="Important Links"
                        links={[
                            {
                                title: 'Home',
                                path: '/',
                                type: 'Link',
                            },
                            {
                                type: 'Link',
                                title: 'About',
                                path: '/about',
                            },
                            {
                                type: 'Link',
                                title: 'Projects',
                                path: '/projects',
                            },
                            {
                                type: 'Link',
                                title: 'Contact',
                                path: '/contact',
                            },
                        ]}
                    />
                </div>
                <div className="footer__col3">
                    <FooterCol
                        heading="Contact Info"
                        links={[
                            {
                                title: '+79101170018',
                                path: 'tel:+79101170018',
                            },
                            {
                                title: 'Russia,Moscow',
                                path: 'https://www.google.ru/maps/place/%D1%83%D0%BB.+%D0%91%D0%BE%D0%BB%D1%8C%D1%88%D0%B0%D1%8F+%D0%9A%D1%80%D0%B0%D1%81%D0%BD%D0%BE%D1%84%D0%BB%D0%BE%D1%82%D1%81%D0%BA%D0%B0%D1%8F,+9,+%D0%A1%D0%BC%D0%BE%D0%BB%D0%B5%D0%BD%D1%81%D0%BA,+%D0%A1%D0%BC%D0%BE%D0%BB%D0%B5%D0%BD%D1%81%D0%BA%D0%B0%D1%8F+%D0%BE%D0%B1%D0%BB.,+214000/@54.7903953,32.0381942,17z/data=!3m1!4b1!4m5!3m4!1s0x46cef7f8552346a5:0x4b46ba20008dd46d!8m2!3d54.7903922!4d32.0403829?hl=ru',
                            },
                        ]}
                    />
                </div>
                <div className="footer__col4">
                    <FooterCol
                        heading="Social Links"
                        links={[
                            {
                                title: 'Telegram',
                                path: 'https://t.me/eremin_maksim_official',
                            },
                            {
                                title: 'Instagram',
                                path: 'https://www.instagram.com/pro100luckys',
                            },
                            {
                                title: 'Whats Up',
                                path: 'https://wa.me/79101170018',
                            },
                        ]}
                    />
                </div>
            </div>
            <div className="copyright">
                <div className="container">
                    <h2 className="reserved">
                        © 2022 - Maks Eremin
                    </h2>
                </div>
            </div>
        </FooterStyle>
    );
}
